// src/utils/api/tron.js
import API from "../api";

function isAuthError(msg = "") {
  return (
    msg.includes("Missing auth token") ||
    msg.includes("Unauthorized") ||
    msg.includes("jwt expired") ||
    msg.includes("invalid token")
  );
}

function extractMessage(err, fallback) {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    fallback
  );
}

export async function createTronIntent({ product, token = "USDT" }) {
  try {
    const res = await API.post("/tron/intent", { product, token });
    const data = res.data;
    if (!data || data.error) throw new Error(data?.message || data?.error || "TRON intent error");
    return data;
  } catch (err) {
    const msg = extractMessage(err, "Failed to create TRON payment intent");
    const e = new Error(isAuthError(msg) ? "Please log in to continue." : msg);
    e.code = isAuthError(msg) ? "AUTH" : "TRON_INTENT";
    throw e;
  }
}

export async function pollTronIntent({ intent, product, referralCode }) {
  try {
    const res = await API.post("/tron/poll-intent", {
      intent,
      product,
      ...(referralCode ? { referralCode } : {}),
    });
    const data = res.data;
    if (data?.error) throw new Error(data.error);
    return data;
  } catch (err) {
    const msg = extractMessage(err, "Poll failed");
    const e = new Error(isAuthError(msg) ? "Please log in to continue." : msg);
    e.code = isAuthError(msg) ? "AUTH" : "TRON_POLL";
    throw e;
  }
}

export async function approveTronPayment({ intent, txHash, product, referralCode }) {
  try {
    const res = await API.post("/tron/approve", {
      intent, txHash, product,
      ...(referralCode ? { referralCode } : {}),
    });
    const data = res.data;
    if (!data || data.error) throw new Error(data?.message || data?.error || "TRON approve error");
    return data;
  } catch (err) {
    const msg = extractMessage(err, "Failed to approve TRON payment");
    const notYetConfirmed = err?.response?.status === 402 || msg.includes("not yet confirmed");
    const e = new Error(
      isAuthError(msg) ? "Please log in to continue."
      : notYetConfirmed ? "Payment not detected yet — please wait a moment and try again."
      : msg
    );
    e.code = isAuthError(msg) ? "AUTH" : notYetConfirmed ? "TRON_NOT_YET" : "TRON_APPROVE";
    throw e;
  }
}

export async function completeTronPayment({ txnId }) {
  try {
    const res = await API.post("/tron/complete", { txnId });
    const data = res.data;
    if (!data || data.error) throw new Error(data?.message || data?.error || "TRON complete error");
    return data;
  } catch (err) {
    const msg = extractMessage(err, "Failed to complete TRON payment");
    const e = new Error(isAuthError(msg) ? "Please log in to continue." : msg);
    e.code = isAuthError(msg) ? "AUTH" : "TRON_COMPLETE";
    throw e;
  }
}

export async function getTronStatus({ txnId }) {
  try {
    const res = await API.get(`/tron/status/${txnId}`);
    const data = res.data;
    if (!data || data.error) throw new Error(data?.message || data?.error || "TRON status error");
    return data;
  } catch (err) {
    const msg = extractMessage(err, "Failed to fetch TRON status");
    const e = new Error(isAuthError(msg) ? "Please log in to continue." : msg);
    e.code = isAuthError(msg) ? "AUTH" : "TRON_STATUS";
    throw e;
  }
}